import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";

class RoomUserFaceDetectorApi extends BaseApi {
    constructor() {
        super();
        Room.User.FaceDetector = this;
        Room.addEventListeners(this._CoreEvents, this);
        Room.ready(async e => {
            this._eventListen(this._Events);
        }, {order: 100});
    }

    async coverFace () {
        let stream = await Room.Call.Stream.getCurrentLocalStream(true);
        if(!stream) return;
        let track = stream.getVideoTracks()[0];
        let trackApp = track?._grm_tg;
        if(!trackApp) return;

        const personalSetting = await Room.CamstudyPersonal.getPersonalSetting();
        let coverFace = personalSetting?.coverFace;

        if(coverFace !== 'on'){
            trackApp.setFaceDrawType(null);
        }else{
            const faceImage = require(`@/assets/roomType/lms/img/emoti-img/grm-face-01.svg`);
            await trackApp.pipeThrough('FaceDetector', {
                drawType: 'faceImage',
                faceImage,
            });
            trackApp.setFaceImage(faceImage);
        }
    }

    _CoreEvents = {
        room_changePersonalSetting: async function(e) {
            this.coverFace();
        }
    }
    _Events = {

    }
}

export const RoomUserFaceDetector = new RoomUserFaceDetectorApi();
